export const attributeTypeCodes = {
  T_SHORT: 'T_SHORT',
  T_LONG: 'T_LONG',
  TEXT: 'TEXT',
  LINK: 'LINK',
  NUM_TXT: 'NUM_TXT',
  NUM_INT: 'NUM_INT',
  NUM_DECIMAL: 'NUM_DECIMAL',
  N_DECIMAL: 'N_DECIMAL',
  LIST: 'LIST',
  F_IMG: 'F_IMG',
  F_GEN: 'F_GEN',
  F_LS_IMG: 'F_LS_IMG',
  BOOL: 'BOOL',
  INT: 'N_INT',
  DATE: 'DATE',
}
